import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { GlgButton, GlgSwitch } from 'SharedComponents'

class FooterSectionComponent extends Component {

  render(){
    const {
      isVisible,
      toggleVisible,
      changeViewDisplayed,
    } = this.props

    return <Fragment><Row className="vertical-align-items"><Col xs={ 12 } sm={ 8 } className="no-padding-left no-margin-top">{ !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_section_component.customize') }</Col><Col xs={ 6 } sm={ 2 } className="no-padding-left"><GlgSwitch text={ [ (!window.I18n ? '' : window.I18n.t('tv_shows.components.footer_section_component.visible')),
                                                       (!window.I18n ? '' : window.I18n.t('tv_shows.components.footer_section_component.hidden')) ] } widthInPixels={ 80 } checked={ isVisible } onChange={ toggleVisible } id="footer-visible-switch"></GlgSwitch></Col><Col xs={ 6 } sm={ 2 } className="no-padding-left"><GlgButton text={ !window.I18n ? '' : window.I18n.t('buttons.edit') } icon="pencil" color="white" onClick={ () => changeViewDisplayed('footerSettings') }></GlgButton></Col></Row></Fragment>
  }
}

FooterSectionComponent.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleVisible: PropTypes.func.isRequired,
  changeViewDisplayed: PropTypes.func.isRequired,
}

export default FooterSectionComponent
